import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "@mui/material";
import { useEffect } from "react";
import { AlertWrapper, SnackBarWrapper } from "./ToasterComponent.style";
import { ToasterRedux } from "../../../redux/toaster-redux/ToasterRedux";
import constants from "../../../core/constants/Constants";
import { HttpResponseTypeEnum } from "../../../core/enumerations/ServerRequestStatusEnum";
import ImageAssets from "../../../assets";

export const ToasterComponent = (props: any) => {
  const actionDispatch = (dispatch: any) => ({
    setToasterNull: () => dispatch(ToasterRedux.actions.setToasterNull()),
  });
  const { setToasterNull } = actionDispatch(useDispatch());

  const dispatch = useDispatch();
  const toaster = useSelector((state: any) => state?.toasterRedux);
  const { toasterDetails } = toaster;

  const status = (toasterDetails?.status === HttpResponseTypeEnum.userCreated || toasterDetails?.status === HttpResponseTypeEnum.Success) ? 'success' : 'error'

  useEffect(() => {
    let timer: any;
    if (toasterDetails) {
      timer = setTimeout(
        () => dispatch(setToasterNull()),
        constants.threeSeconds
      );
    }
    return () => clearTimeout(timer);
  }, [toasterDetails]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      {props.children}
      {toasterDetails?.status && (
        <SnackBarWrapper
          autoHideDuration={constants.fiveHundredSeconds}
          open={toasterDetails?.toasterOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => dispatch(setToasterNull())}
        >
          <AlertWrapper>
            <Alert
              severity={
                toasterDetails?.status === HttpResponseTypeEnum.userCreated ||
                  toasterDetails?.status === HttpResponseTypeEnum.Success
                  ? "success"
                  : toasterDetails?.status !==
                    HttpResponseTypeEnum.userCreated ||
                    toasterDetails?.status !== HttpResponseTypeEnum.Success
                    ? "error"
                    : undefined
              }
              icon={
                <img
                  alt="snackbar-icon"
                  style={status ?
                    {
                      filter: status === 'success' ?
                        'brightness(0) saturate(100%) invert(88%) sepia(29%) saturate(600%) hue-rotate(98deg) brightness(95%) contrast(94%)' :
                        'brightness(0) saturate(100%) invert(56%) sepia(49%) saturate(519%) hue-rotate(300deg) brightness(101%) contrast(101%)'
                    }
                    : null
                  }
                  src={
                    toasterDetails?.status ===
                      HttpResponseTypeEnum.userCreated ||
                      toasterDetails?.status === HttpResponseTypeEnum.Success
                      ? ImageAssets.ic_snackbar_success
                      : ImageAssets.ic_snackbar_failure
                  }
                  className="snackbar-icon"
                />
              }
              className="alert-style"
              variant="filled"
            >
              <div className={`toaster-message ${status} } `}>
                {toasterDetails?.data?.message}
              </div>
            </Alert>
          </AlertWrapper>
        </SnackBarWrapper>
      )}
    </div>
  );
};
